import { useCallback } from 'react';
import { ProductContext } from '../../preload/pages/ProductPage/providers/ProductProvider';
import useContext from '../useContext';
import { useEmitAddToCart } from './useTrackingEvents';

import { ConfigurationContext } from '../../preload/pages/ProductPage/providers/ConfigurationProvider';

export default () => {
  const { configurations, variantId: mainProductVariantId } = useContext(ProductContext) || {};
  const { selection } = useContext(ConfigurationContext) || {};
  const emit = useEmitAddToCart();

  return useCallback(
    (variantId: string) => {
      // This is only the case when tracked variantId matches the one from the product context
      const isMainProduct = mainProductVariantId === variantId;
      const upholster = selection?.['sofaUpholster'];

      if (!isMainProduct || !configurations?.length || !upholster) {
        emit(variantId);
      } else {
        const variant = configurations
          ?.find((c) => c.type === 'sofaUpholster')
          ?.items?.find((i) => i.id === upholster)?.name;
        emit(variantId, variant);
      }
    },
    [configurations, selection],
  );
};
